module.exports = __webpack_public_path__ + "img/plage.dc175199.jpg";